import React from "react"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "lib/store"
import { hideEditSidebar } from "lib/store/services/editSidebar/slice"
import { ProductVariant } from "lib/types/generated/graphql-types"

import EditSidebar from "components/Ui/EditSidebar/EditSidebar"
import EditSidebarHeader from "components/Ui/EditSidebar/EditSidebarHeader"
import Box from "components/Ui/Box"
import Status from "components/Ui/Status"
import DimensionsComponent from "components/Products/Dimensions"
import { ProductVariantDisplayAttributes } from "components/Products/ProductVariantDisplayAttributes"
import { Label, Value } from "components/Ui/List/List"
import { ProductVariantCustomAttributes } from "components/Products/ProductVariantCustomAttributes"
import { ProductVariantTags } from "components/Products/ProductVariantTags"
import { ProductVariantStock } from "components/Products/Stock/ProductVariantStock"
import { ProductVariantShippingAttributes } from "../../components/Products/ProductVariantShippingAttributes"
import { handleImageError } from "helpers/image"
import {
  Description,
  Image,
  ImageWrapper,
  Parent,
  StyledItem,
  StyledList
} from "./ShowVariant.styled"

type Props = {
  variant: ProductVariant
  showParent?: boolean
  cancelEvent?: () => void
}

const ShowVariant = ({ variant, showParent, cancelEvent }: Props) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  return (
    <EditSidebar cancelEvent={cancelEvent}>
      <Box padding="0" margin="0">
        <EditSidebarHeader
          title={
            <>
              {variant.name} <Status status={variant.isActive ? "Active" : "Inactive"} />
            </>
          }
          id={variant.id}
        >
          {showParent ? (
            <>
              <div>Parent:</div>
              <Parent
                onClick={() => {
                  dispatch(hideEditSidebar())
                  navigate(`/products/${variant.productParentId}`)
                }}
              >
                {variant.productParentId}
              </Parent>
            </>
          ) : (
            <></>
          )}
        </EditSidebarHeader>
        <ImageWrapper>
          <Image src={variant?.imageUrl ?? ""} onError={handleImageError} />
        </ImageWrapper>
        <DimensionsComponent variant={variant} />
        <StyledList>
          <StyledItem>
            <Label>Tax group:</Label>
            <Value>{variant.TaxGroup.name}</Value>
          </StyledItem>
          {variant?.taxCode && <StyledItem>
            <Label>Tax code:</Label>
            <Value>{variant?.taxCode}</Value>
          </StyledItem>}
          <StyledItem>
            <Label>Created:</Label>
            <Value>{dayjs(variant.created).format("YYYY-MM-DD")}</Value>
          </StyledItem>
          <StyledItem>
            <Label>Updated:</Label>
            <Value>{dayjs(variant.updated).format("YYYY-MM-DD")}</Value>
          </StyledItem>
        </StyledList>
        <Description>
          <Label>Description:</Label> <p>{variant.description || "No description added"}</p>
        </Description>
        <ProductVariantStock stock={variant.Stock} variantId={variant.id} />
        <ProductVariantCustomAttributes
          customAttributes={JSON.parse(variant.customAttributes)}
          insideEditSidebar={true}
        />
        <ProductVariantDisplayAttributes attributes={variant.displayNames} name={true} />
        <ProductVariantDisplayAttributes attributes={variant.displayDescriptions} name={false} />
        <ProductVariantTags tags={JSON.parse(variant.tags)} insideEditSidebar={true} />
        <ProductVariantShippingAttributes shippingAttributes={variant?.shippingAttributes} />
      </Box>
    </EditSidebar>
  )
}

export default ShowVariant
